// extracted by mini-css-extract-plugin
module.exports = {"popoverButton":"PopoverWrapper_popoverButton__1u3B3","popoverIcon":"PopoverWrapper_popoverIcon__3l1Ty","content":"PopoverWrapper_content__17hkR"};